import useTranslate from '../hooks/useTranslate';

function PageNotFound(): JSX.Element {
  const t = useTranslate();

  return <div dangerouslySetInnerHTML={{ __html: t('error.tree:page_not_found') }} />;
}

export default PageNotFound;
